import React from "react";
import { Link } from "react-router-dom";

import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import CallIcon from "@mui/icons-material/Call";

import LoginModal from "./loginModal";
import SignUpModal from "./signUpModal";
import DrawerMenu from "./drawerLogin";
import DrawerWithoutLogin from "./drawerWithoutLogin";
// import LoginOtp from "./loginOtp";

const HeaderRight = () => {
  return (
    <div className="header-top-right">
      <div className="header-email">
        <AlternateEmailIcon sx={{ fontSize: 16 }} />
        <Link to="mailto:info@skycars.in"> info@skycars.in</Link>
      </div>
      <div className="header-phone">
        <CallIcon sx={{ fontSize: 16 }} />
        <Link to="tel:+91-12341234"> +91 1234 1234</Link>
      </div>
      <div className="header-menu">
        <Link to="/aboutus">About Us</Link>
      </div>
      <div className="header-login-btn d-flex">
        {/* <LoginOtp title="Login " login="Login" /> / */}
        <LoginModal title="Login " login="Login" />/
        <SignUpModal title="Sign Up " signup="SignUp" />
        {/* <Link to="">Signup</Link>    */}
      </div>

      {/* ----with-login--- */}
      <div class="main-wrap">
        <div className="with-login">
          <DrawerMenu />
        </div>
        {/* <div class="whitout-login">
          <DrawerWithoutLogin />
        </div> */}
      </div>
    </div>
  );
};

export default HeaderRight;
